module.exports = __webpack_public_path__ + "img/ic_20_delete_white.b46bec90.svg";